<template>
  <div>
    <v-container>
      <ExemptMortgageesComp />
    </v-container>
  </div>
</template>

<script>
import ExemptMortgageesComp from '../../components/Mtg/Transaction/ExemptMortgageesList.vue';

export default {
  name: 'ExemptMortgagees',
  components: {
    ExemptMortgageesComp,
  },
};

</script>
